import { render, staticRenderFns } from "./GlobalHeader.vue?vue&type=template&id=055ddbba"
import script from "./GlobalHeader.vue?vue&type=script&lang=js"
export * from "./GlobalHeader.vue?vue&type=script&lang=js"
import style0 from "./GlobalHeader.vue?vue&type=style&index=0&id=055ddbba&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports